/**
 * Coerce `reactionCounts` into a plain object regardless of how it arrived.
 *
 * AppSync types the field as `AWSJSON`, so depending on the resolver, the
 * Apollo cache, or the subscription path, the value can land at the UI as
 * either a parsed object or a JSON string. Spreading or `Object.entries`-ing
 * a string treats each character as an entry (we shipped exactly that
 * regression on 2026-05-15 — `{"thumbsup":1}` rendered as 14 pills, one per
 * character), so any code that handles `reactionCounts` must first run it
 * through here.
 *
 * Returns `null` if the value is missing, empty, or unparseable. Returns
 * the plain object otherwise.
 */
export function parseReactionCounts(value) {
  if (value == null) return null;
  if (typeof value === 'object' && !Array.isArray(value)) {
    return value;
  }
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}
